import React from 'react';
import {
  DocumentTextIcon,
  ScaleIcon,
  ShieldCheckIcon,
  GlobeAltIcon,
} from '@heroicons/react/24/outline';

export interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
}

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  document: DocumentTextIcon,
  scale: ScaleIcon,
  shield: ShieldCheckIcon,
  globe: GlobeAltIcon,
};

export const ServiceCard: React.FC<ServiceCardProps> = ({
  icon,
  title,
  description,
}) => {
  const IconComponent = iconMap[icon];

  if (!IconComponent) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm hover:shadow-lg transition-shadow duration-300">
      <div className="mb-4 w-fit flex justify-start items-center bg-atlantis-600/10 rounded-lg p-2">
        <IconComponent className="w-8 h-8 text-atlantis-900" />
      </div>
      <h3 className="text-xl font-bold text-juridico mb-3">{title}</h3>
      <p className="text-titan text-sm leading-relaxed">{description}</p>
    </div>
  );
};

